import React from 'react'

import Svg from './'

const SvgSearch = props => (
  <Svg {...props} viewBox="0 0 40 38.9">
    <path d="M39.5 35.5L28.3 24.3c1.7-2.5 2.7-5.5 2.7-8.8C31 7 24 0 15.5 0S0 7 0 15.5 7 31 15.5 31c3.8 0 7.3-1.4 10-3.7l11 11.1c.8.8 2.1.8 2.9 0 .8-.9.8-2.1.1-2.9zm-24-6.5C8.1 29 2 22.9 2 15.5S8.1 2 15.5 2 29 8.1 29 15.5 22.9 29 15.5 29z" />
  </Svg>
)

export default SvgSearch



// WEBPACK FOOTER //
// ../source/components/Svg/SvgSearch.js